import React from "react";

const PageHero = ({ title, subtitle, kicker }) => {
  return (
    <section className="pt-[110px] md:pt-[140px] pb-10 md:pb-14 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        {kicker && (
          <div className="flex items-center gap-3 mb-4 md:mb-5">
            <span className="h-[2px] w-8 md:w-10 bg-[#C9A24B]" />
            <span className="text-[#C9A24B] text-[11px] md:text-xs font-semibold tracking-[0.24em] uppercase">
              {kicker}
            </span>
          </div>
        )}
        <h1 className="text-3xl sm:text-4xl md:text-6xl font-black tracking-tight text-[#1a1a1a] leading-[1.05]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 md:mt-6 text-base md:text-xl text-neutral-600 max-w-3xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
